<script>
import firebase from 'firebase/compat/app';

export default {
  data: () => ({
    continueMessageLenderAfterLogin: false,
  }),
  methods: {
    toInbox: async function (item) {
      let uid = item.userID;

      await firebase
        .firestore()
        .collection('users')
        .doc(uid)
        .get()
        .then((querySnapshot) => {
          // this.avatar =  querySnapshot.data().avatar

          console.log(querySnapshot.data());
          this.avatarPic = querySnapshot.data().avatar;
        });

      console.log('to inbox');
      localStorage.setItem('chatUser', JSON.stringify(item));
      localStorage.setItem('chatUserAvatar', this.avatarPic);
      // if (!this.userIsAuthenticated) {
      //   this.loginDialog = true;
      //   this.continueMessageLenderAfterLogin = true;
      // }
      // else {
      this.$router.push('/inbox');
      // }
    },
  },
  watch: {
    async user() {
      console.log('watch user loop');
      if (this.continueMessageLenderAfterLogin && this.userWatch == true) {
        this.userWatch = false;
        this.loading = true;
        await this.$store
          .dispatch('loadRooms', this.user)
          .then(async (response) => {
            localStorage.setItem('chatUser', JSON.stringify(this.item));
            localStorage.setItem('chatUserAvatar', this.avatarPic);
            console.log('loaded rooms on async', response);
            await this.delay(1000);
            this.loading = false;
            this.$router.push('/inbox');
          });
      }
    },
  },
  created() {
    this.$store.dispatch('requests/loadRequests');
  },
  computed: {
    requests() {
      return this.$store.state.requests.requests;
    },
  },
};
</script>

<template>
  <v-container class="pt-5">
    <div class="grid mb-5">
      <!-- <div class="text-uppercase font-weight-bold body-2 secondary--text mb-2">
        requests
      </div> -->
      <h2
        style="font-weight: 400 !important; color: rgb(34, 34, 34) !important"
        class="text-h4 text-lg-h4 mb-6 mt-6"
      >
        Some Items people are looking for
      </h2>
    </div>

    <v-row>
      <v-col cols="12">
        <div class="d-flex justify-center">
          <template>
            <v-row class="mx-auto" style="max-width: 1094px">
              <v-col
                v-for="item in requests.slice(0, 3)"
                :key="item.id"
                style="cursor: pointer"
                cols="6"
                sm="4"
                md="3"
              >
                <div class="item" @click="toInbox(item)">
                  <v-card
                    :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                    :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                    style="border-radius: 12px"
                  >
                    <v-img
                      v-if="item.images.length > 0"
                      :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                      :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                      :src="item.images ? item.images[0] : ''"
                    />
                    <v-img
                      v-else
                      :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                      :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                      :src="require('@/assets/logos/icon1.svg')"
                    />
                  </v-card>
                  <v-row
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'max-width: 230px;'
                        : 'max-width: 250px;'
                    "
                    class="font-weight-light text-body-2 px-3 mt-1"
                  >
                    <span class="mr-3"
                      >{{ item.created_by }} is looking for a
                      <strong>{{ item.name }}</strong> in
                      <strong> {{ item.area }}</strong></span
                    >
                  </v-row>

                  <v-row
                    class="ml-auto mr-auto mt-4"
                    style="max-width: 250px; margin-top: 15px !important"
                  >
                    <p class="secondary--text text-body-2">
                      R{{ item.dailyFee }} p/day
                    </p>
                  </v-row>
                  <v-row>
                    <v-btn
                      class="white--text font-weight-medium mb-3 white app--text"
                      color="#b22af0"
                      rounded
                      small
                      elevation="6"
                      id="message-lender-home-requests"
                      @click="toInbox(item)"
                      z-index="12"
                    >
                      message {{ item.created_by
                      }}<v-icon small class="ml-2">fas fa-chevron-right</v-icon>
                    </v-btn>
                  </v-row>
                </div>
              </v-col>

              <v-col cols="6" sm="4" md="3">
                <div class="item" to="/item-requests">
                  <v-card
                    style="cursor: pointer; border-radius: 12px"
                    class="item card grid"
                    height="200px"
                    outlined
                    to="/item-requests"
                    width="250px"
                  >
                    <p class="text-caption text-md-body-1">
                      View More requests
                    </p>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </template>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.grid {
  display: grid;
  place-items: center;
}
.clip {
  text-overflow: clip;
  white-space: nowrap;
  overflow: hidden;
}
.card {
  border-color: rgb(221, 221, 221);
}
.card:hover {
  border-color: rgb(34, 34, 34);
}
.itmcrd {
  transition: opacity 0s ease-in-out;
}
.itmcrd:hover {
  opacity: 0.8;
}
</style>
